var _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAppBm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 6C36.5 3.6 35.1667 3 34.5 3H21.5V8.5L24.5 14.5V19.5L18.5 26.5V41.5C24.1 44.3 29.5 41.3333 31.5 39.5L34 37C34 37.3333 34.5 38.1 36.5 38.5C38.5 38.9 39.3333 37 39.5 36H46V27.5H39.5C39.1667 27.5 38.5 27.1 38.5 25.5C38.5 23.9 35.1667 24.1667 33.5 24.5L30 19.5C30.5 19 31.5 17.8 31.5 17C31.5 16 30.5 14.5 28.5 14.5C28.5 10.5 31.8333 8.83333 33.5 8.5C34.5 8.33333 36.5 7.6 36.5 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 24.5L17.5 19.5H29.5L34 25.5V38L31.5 39.1915C29.5 43.5 17.5 43.5 15.5 39.1915L13.5 38V24.5Z",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27.5L39 26.5C39 25.1193 37.8807 24 36.5 24V24C35.1193 24 34 25.1193 34 26.5L34 36.5C34 37.8807 35.1193 39 36.5 39V39C37.8807 39 39 37.8807 39 36.5L39 36M39 27.5L45.5 27.5M39 27.5L39 36M39 36L45.5 36",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 14.5H18.9996C17.6189 14.5 16.4996 15.6193 16.4996 17V17C16.4996 18.3807 17.6189 19.5 18.9996 19.5H28.9996C30.3803 19.5 31.4996 18.3807 31.4996 17V17C31.4996 15.6193 30.3803 14.5 28.9996 14.5H28.4996M19.9996 14.5C19.9996 11.5 17.5 8 14.5 8M19.9996 14.5L28.4996 14.5M28.4996 14.5C28.4996 11.5 32 8 33.9998 8",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 35.5L8.5 36.5C8.5 37.8807 9.61929 39 11 39V39C12.3807 39 13.5 37.8807 13.5 36.5L13.5 26.5C13.5 25.1193 12.3807 24 11 24V24C9.61929 24 8.5 25.1193 8.5 26.5L8.5 27.5M8.5 35.5L1.5 35.5M8.5 35.5L8.5 27.5M8.5 27.5L1.5 27.5",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 3,
    width: 24,
    height: 5,
    rx: 2.5,
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppBm);
export default __webpack_public_path__ + "static/media/icon-app-bm.8425a2e9045e7c922e65a0031cc5d9e5.svg";
export { ForwardRef as ReactComponent };